import api from './api';

export interface User {
  id: string;
  name: string;
  email: string;
  role: 'super_admin' | 'admin' | 'researcher' | 'contributor';
  status: 'pending_approval' | 'active' | 'suspended';
  demo_request: boolean;
  country?: string;
  sector?: string;
  created_at: string;
  updated_at: string;
}

export interface UserApproveRequest {
  role: 'super_admin' | 'admin' | 'researcher' | 'contributor';
}

export const getUsers = async (demoRequest?: boolean | null): Promise<User[]> => {
  const params: any = {};
  if (demoRequest !== undefined && demoRequest !== null) {
    params.demo_request = demoRequest;
  }
  const response = await api.get('/users/', { params });
  return response.data;
};

export const approveUser = async (userId: string, role: UserApproveRequest): Promise<User> => {
  const response = await api.post(`/users/${userId}/approve`, role);
  return response.data;
};

export const suspendUser = async (userId: string): Promise<User> => {
  const response = await api.post(`/users/${userId}/suspend`);
  return response.data;
};

export const activateUser = async (userId: string): Promise<User> => {
  const response = await api.put(`/users/${userId}`, { status: 'active' });
  return response.data;
};

export const updateUserRole = async (userId: string, role: User['role']): Promise<User> => {
  const response = await api.put(`/users/${userId}`, { role });
  return response.data;
};

export const deleteUser = async (userId: string): Promise<User> => {
  const response = await api.delete(`/users/${userId}`);
  return response.data;
};
